import React from "react";
import { Button, CircularProgress, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import Modal from "Components/Common/Modal";

import { usePostRescheduleAuditDatesMutation } from "apis/AuditSchedular";
import DatePicker from "Components/Common/DatePicker";
import { withTranslation } from "react-i18next";
import moment from "moment";

const FireSafetyConsumerAuditScheduler = ({
  developerBuildingId,
  handleClose,
  t,
}) => {
  const [addSchedulerDates, { isLoading: isDatesAdding }] =
    usePostRescheduleAuditDatesMutation();

  const formik = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
      developerBuildingId,
    },
    validationSchema: Yup.object({
      startDate: Yup.date().test("isValidStartDate", "", function () {
        const [{ value: { startDate } = null } = {}] = this.from || [];

        if (!startDate) {
          return this.createError({
            message: "Start date is required",
          });
        }

        if (startDate.isBefore(moment())) {
          return this.createError({
            message: "Please enter a future date",
          });
        }

        return true;
      }),
      endDate: Yup.date().test("isValidEndDate", "", function () {
        const [{ value: { startDate, endDate } = null } = {}] = this.from || [];
        if (!endDate?.isValid()) {
          return this.createError({
            message: "End date is required",
          });
        }
        if (startDate && startDate.isAfter(endDate)) {
          return this.createError({
            message: "End date should be after start date",
          });
        }

        return true;
      }),
    }),
    onSubmit: async ({ developerBuildingId, startDate, endDate }) => {
      try {
        await addSchedulerDates({
          startDate: startDate.format("YYYY-MM-DD"),
          endDate: endDate.format("YYYY-MM-DD"),
          developerBuildingId,
        });
        handleClose(true);
      } catch (error) {}
    },
  });

  const {
    handleSubmit,
    values: { startDate },
  } = formik;

  return (
    <Modal
      isOpen
      handleClose={() => handleClose(false)}
      maxWidth="sm"
      title="Add Reschedule Dates"
    >
      <Grid container className="mt-3" columnSpacing={2}>
        <Grid item xs={12}>
          <DatePicker
            label={t("Start Date") + "*"}
            name="startDate"
            formik={formik}
            disablePast
            format="DD-MM-YYYY"
          />
        </Grid>

        <Grid item xs={12}>
          <DatePicker
            label={t("End Date") + "*"}
            name="endDate"
            disablePast
            formik={formik}
            minDate={moment(startDate)}
            format="DD-MM-YYYY"
          />
        </Grid>

        <Grid item xs={12} className="d-flex justify-content-end">
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            endIcon={isDatesAdding && <CircularProgress size={20} />}
            disabled={isDatesAdding}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

FireSafetyConsumerAuditScheduler.propTypes = {
  t: PropTypes.func,
  handleClose: PropTypes.func,
  developerBuildingId: PropTypes.number,
};

export default withTranslation()(FireSafetyConsumerAuditScheduler);
